import { useEffect } from "react";
import { useSettings } from "@/contexts/SettingsContext";

/** Applies the admin-selected theme class to <html>. */
export default function ThemeApplier() {
  const { settings } = useSettings();
  useEffect(() => {
    const theme = settings?.theme || "dark";
    document.documentElement.classList.remove("theme-dark", "theme-light");
    document.documentElement.classList.add(`theme-${theme}`);
    document.documentElement.style.colorScheme = theme;
  }, [settings?.theme]);
  return null;
}
